import { render } from "./connect-button.vue?vue&type=template&id=6ac1a607&lang=pug"
import script from "./connect-button.vue?vue&type=script&setup=true&lang=js"
export * from "./connect-button.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__